<template>
    <div class="col-md-6 border-0">
        <div class="ibox dasboard_graph">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">Compliance Summary</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="ibox-content pt-0">
                <table class="table dataTable">
                        <thead>
                            <tr class="table-head">
                                <td class="text-center" style="max-width:180px;">Compliance</td>
                                <td class="text-center" style="max-width:140px;">Last Submission Date</td>
                                <td class="text-center" style="max-width:60px;">Status</td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr class="hover-bg table-row border-bottom">

                            <td class="text-left" style="max-width:180px;">Challan</td>
                            <td style="max-width:140px;">{{companies.latest_challans|| compliance_placeholder}}</td>
                            <td class="compiance-btn-td" >
                                <button type="button" id="challan-btn"  :class="[{ 'btn-submitted' : companies.challan_past_due == 0},{ 'btn-due' : companies.challan_past_due == 1},{ 'btn-undefined' : companies.sod_past_due == undefined}, { 'btn-overdue' : companies.challan_past_due == 2},'btn compliance_btn']">

                                    <span  class='btn_span'>

                                        {{getBtnStatus(companies.challan_past_due)}}
                                    </span>
                                </button>

                                    <b-tooltip placement="top" target="challan-btn" triggers="hover">
                                    {{getBtnStatus(companies.challan_past_due)}}
                                    </b-tooltip>

                            </td>

                        </tr>
                        <tr class="hover-bg table-row border-bottom">
                            <td class="text-left" style="max-width:180px;">Monthly Salary Statement</td>
                            <td>{{companies.latest_sod || compliance_placeholder}}</td>
                            <td class="compiance-btn-td" >
                                <button type="button"  id="sod-btn"  :class="[{ 'btn-submitted' : companies.sod_past_due == 0},{ 'btn-due' : companies.sod_past_due == 1}, { 'btn-overdue' : companies.sod_past_due == 2},{ 'btn-undefined' : companies.sod_past_due == undefined},'btn compliance_btn']">
                                    <span  class='btn_span'>
                                        {{getBtnStatus(companies.sod_past_due)}}
                                    </span>

                                </button>

                                <b-tooltip placement="top" target="sod-btn" triggers="hover">
                                    {{getBtnStatus(companies.sod_past_due)}}
                                </b-tooltip>

                            </td>
                        </tr>
                        <tr class="hover-bg table-row border-bottom">
                            <td class="text-left" style="max-width:180px;">108 Return</td>
                            <td>{{companies.latest_108 || compliance_placeholder}}</td>
                            <td class="compiance-btn-td" >
                                <button type="button" id="latest_108-btn" :class="[{ 'btn-submitted' : companies.latest_108_past_due == 0},{ 'btn-due' : companies.latest_108_past_due == 1},{ 'btn-undefined' : companies.sod_past_due == undefined}, { 'btn-overdue' : companies.latest_108_past_due == 2},'btn compliance_btn']">
                                    <span class='btn_span'>
                                        {{getBtnStatus(companies.latest_108_past_due)}}
                                    </span>

                                </button>
                                <b-tooltip placement="top" target="latest_108-btn" triggers="hover">
                                    {{getBtnStatus(companies.latest_108_past_due)}}
                                </b-tooltip>

                            </td>

                        </tr>
                        <tr class="hover-bg table-row border-bottom">
                            <td class="text-left" style="max-width:180px;">108A Return</td>
                            <td>{{ companies.latest_108a || compliance_placeholder }}</td>
                            <td class="compiance-btn-td">
                                <!-- Abdullah26 chnaged this btn to add spacee  -->
                                <button type="button" id="latest_108a-btn"
                                    :class="[{ 'btn-submitted': companies.latest_108a_past_due == 0 }, { 'btn-due': companies.latest_108a_past_due == 1 }, { 'btn-undefined': companies.sod_past_due == undefined }, { 'btn-overdue': companies.latest_108a_past_due == 2 }, 'btn compliance_btn']">
                                    <span class='btn_span'>
                                        {{ getBtnStatus(companies.latest_108a_past_due) }}
                                    </span>

                                </button>

                                <b-tooltip placement="top" target="latest_108a-btn" triggers="hover">
                                    {{getBtnStatus(companies.latest_108a_past_due)}}
                                </b-tooltip>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default{

        mounted() {

        },
        props: ['pageurl'],
        components: {

        },
        data(){

            return {
                notice: "No compliance summary found since you have no company listed yet!",
                pagetitle: 'Companies',
                companies:[],
                blankmsg : 'Hold your breath, we are currently fetching your compliance summary list ...',
                compliance_placeholder : 'N/A',
                length: 10,


            }
        },
        methods:{
            getBtnStatus: function(status)
            {
                if(status==0)
                {
                    return 'Submitted';
                }
                else if(status==1)
                {
                    return 'Due';
                }
                else if(status==2)
                {
                    return 'Overdue';
                }
                else
                {
                    return 'Due';
                }

            },
            getCompanyData: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.pageurl+'/company/compliance-summary' , {

                }).then(function(response){


                    this.showoverlay = false;
                    //console.log(response.data);
                    this.companies =response.data;



                    var currentdate = new Date();
                    let last_payrun = this.companies.latest_payrun;
                    let last_challan = this.companies.latest_challans;
                    let last_salary_statement = this.companies.latest_sod;
                    let last_108 = this.companies.latest_108;
                    let last_108a = this.companies.latest_108a;


                    const last_payrun_date = last_payrun.split('/');
                    var last_payrun_date_final = new Date(parseInt(last_payrun_date[0]),parseInt(last_payrun_date[1])-1,parseInt(last_payrun_date[2]));

                    if(last_challan!='')
                    {

                    }
                    else
                    {

                    }

                    //console.log(last_payrun_date_final);
                }.bind(this));
            },

        },
        created: function(){
            this.getCompanyData();
        },
        computed:
        {

        }
    }
</script>


